import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=45444fed"
import script from "./contacts.ts?vue&type=script&lang=js&external"
export * from "./contacts.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports